import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GetLocationListResponseType } from 'features/Location/@types/location'
import { AssetSupplyOrderMoveableAssetResponseInterface } from 'features/AssetManagement/@types/typeSupplyOrder'

type LocationListType = GetLocationListResponseType['content']

export type SelectedLocationItemType = Pick<
  LocationListType[number],
  'location_id' | 'location_name'
>

type SelectedItemType = Pick<
  AssetSupplyOrderMoveableAssetResponseInterface['data'][number],
  'asset_inventory_id' | 'code'
>

export type HandheldMonitoringInitialStateType = {
  isLoading: boolean
  filter: {
    selectedLocation: Nullable<SelectedLocationItemType>
    searchValue: string
    pageSize: number
    pageIndex: number
  }
  locationList: LocationListType
  listData: AssetSupplyOrderMoveableAssetResponseInterface['data']
  hasNext: boolean
  selectedItemList: string[]
  modalUnregister: {
    isOpen: boolean
    type: 'single' | 'multiple'
    itemData: SelectedItemType
    isSubmittingData: boolean
  }
}

const initialState: HandheldMonitoringInitialStateType = {
  isLoading: false,
  filter: {
    selectedLocation: null,
    searchValue: '',
    pageSize: 10,
    pageIndex: 0,
  },
  locationList: [],
  listData: [],
  hasNext: false,
  selectedItemList: [],
  modalUnregister: {
    isOpen: false,
    type: 'single',
    itemData: {
      asset_inventory_id: '0',
      code: '',
    },
    isSubmittingData: false,
  },
}

const handheldMonitoring = createSlice({
  name: 'handheldMonitoring',
  initialState,
  reducers: {
    reset: () => initialState,
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setHandheldResponseData: (
      state,
      action: PayloadAction<AssetSupplyOrderMoveableAssetResponseInterface>,
    ) => {
      state.listData = action.payload.data
      state.hasNext = action.payload.has_next
    },
    setLocationList: (state, action: PayloadAction<LocationListType>) => {
      state.locationList = action.payload
    },
    setFilterData: (
      state,
      action: PayloadAction<Partial<HandheldMonitoringInitialStateType['filter']>>,
    ) => {
      state.filter = {
        ...state.filter,
        ...action.payload,
      }
    },
    setSelectedItemListData: (state, action: PayloadAction<string[]>) => {
      state.selectedItemList = action.payload
    },
    setModalUnregister: (
      state,
      action: PayloadAction<Partial<HandheldMonitoringInitialStateType['modalUnregister']>>,
    ) => {
      state.modalUnregister = {
        ...state.modalUnregister,
        ...action.payload,
      }
    },
    resetModalUnregister: (state) => {
      state.modalUnregister = initialState.modalUnregister
    },
  },
})

export const {
  reset,
  setIsLoading,
  setHandheldResponseData,
  setLocationList,
  setFilterData,
  setSelectedItemListData,
  setModalUnregister,
  resetModalUnregister,
} = handheldMonitoring.actions

export default handheldMonitoring.reducer
